import React, { useEffect, useState } from "react"
import { motion } from "framer-motion"
import { useSelector, useDispatch } from "react-redux"
import { setUserDetails } from "../../Store/Auth/actions"
import { useLanguage } from "../../Common/LanguageContext"
import API from "../../Common/API"
import PlansTab from "./PlansTab"
import PaymentModal from "./PaymentModal"

const MemberPlans = () => {
    const dispatch    = useDispatch()
    const userDetails = useSelector((s) => s.auth.userDetails)
    const { t }       = useLanguage()

    const [plans,    setPlans]    = useState([])
    const [planInfo, setPlanInfo] = useState(null)
    const [payModal, setPayModal] = useState(null)

    useEffect(() => {
        if (!userDetails?._id) return
        API.get(`/plans/getSubscribedPlanDetailsByUserId/${userDetails._id}`)
            .then(r => { const d = r.data?.data; if (d?.planId) setPlanInfo(d.planId) })
            .catch(() => {})
        API.get("/plans/getPlansList")
            .then(r => setPlans(r.data?.data || []))
            .catch(() => {})
    }, [userDetails?._id])

    const handlePaymentSuccess = async () => {
        try {
            const r = await API.get(`/user/getUserDetailsById/${userDetails._id}`)
            const updatedUser = r.data?.data
            if (updatedUser) {
                dispatch(setUserDetails(updatedUser))
                if (updatedUser.planId) {
                    API.get(`/plans/getSubscribedPlanDetailsByUserId/${updatedUser._id}`)
                        .then(r2 => { const d = r2.data?.data; if (d?.planId) setPlanInfo(d.planId) })
                }
            }
        } catch (_) {}
        setPayModal(null)
    }

    return (
        <motion.div
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            className="mx-auto max-w-3xl space-y-5 px-4 py-6 md:px-6"
        >
            <div>
                <p className="text-xs font-bold uppercase tracking-[0.18em] text-primeColor">{t("myAccount")}</p>
                <h2 className="mt-1 text-2xl font-semibold text-tColor">{t("plansTab") || "Plans"}</h2>
            </div>

            <PlansTab
                plans={plans}
                userDetails={userDetails}
                planInfo={planInfo}
                onSelectPlan={(p) => setPayModal(p)}
                t={t}
            />

            <PaymentModal
                open={!!payModal}
                plan={payModal}
                onClose={() => setPayModal(null)}
                onSuccess={handlePaymentSuccess}
            />
        </motion.div>
    )
}

export default MemberPlans
